var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('el-link',{attrs:{"underline":false,"type":"primary","icon":"el-icon-share"},on:{"click":_vm.handleShare}},[_vm._v(" Udostępnij ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }